import React, { useEffect, useState, Fragment } from "react";
import styled from "styled-components";
import _ from "underscore";
import Link from "../../Link";
import { fetchJson, post } from "../../../lib/Fetching";

const SearchBox = styled.input`
  width: 150px;
  display: inline-block;
  height: 25px;
  margin-left: 20px;
`;

export default function CategoryTestings({ tests, reload, categoryId }) {
  const [selectedIds, setSelectedIds] = useState([]);
  const [techniqueFilter, setTechniqueFilter] = useState("");
  const [matrixFilter, setMatrixFilter] = useState("");
  const [testNameFilter, setTestNameFilter] = useState("");

  const select = (ids, checked) => {
    if (checked) {
      setSelectedIds(_.uniq(selectedIds.concat(ids)));
    } else {
      setSelectedIds(_.uniq(selectedIds.filter((sId) => !ids.includes(sId))));
    }
  };

  const deleteSelected = () => {
    if (
      !confirm(
        "Are you sure you want to delete " +
          selectedIds.length +
          " selected items from this category?"
      )
    ) {
      return;
    }
    post(
      "/testing/categories/" + categoryId + "/category_testings/destroy.json",
      {
        ids: selectedIds,
      },
      "DELETE"
    ).then(() => {
      reload();
      setSelectedIds([]);
      alert("Successfully deleted");
    });
  };

  var filteredTests = tests;
  if (techniqueFilter !== "") {
    const tRegex = new RegExp(techniqueFilter, "i");
    filteredTests = filteredTests.filter((t) => tRegex.test(t.technique));
  }
  if (matrixFilter !== "") {
    const mRegex = new RegExp(matrixFilter, "i");
    filteredTests = filteredTests.filter((t) => mRegex.test(t.matrix));
  }
  if (testNameFilter !== "") {
    const nRegex = new RegExp(testNameFilter, "i");
    filteredTests = filteredTests.filter((t) => nRegex.test(t.measurement));
  }

  if (tests.length === 0) return null;

  return (
    <div style={{ maxWidth: 1600 }} className="basic-panel with-padding">
      <p>
        <b>{tests.length}</b> rows &nbsp;&nbsp;|&nbsp;&nbsp;
        <b>{selectedIds.length}</b> selected rows &nbsp;&nbsp;|&nbsp;&nbsp;
        <Link onClick={() => select(filteredTests.map((t) => t.id), true)}>
          Select Visible
        </Link>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        <Link onClick={() => setSelectedIds([])}>Select None</Link>
        &nbsp;&nbsp;|&nbsp;&nbsp;
        {selectedIds.length > 0 && (
          <Link style={{ color: "red" }} onClick={deleteSelected}>
            Delete Selected
          </Link>
        )}
      </p>
      <table className="table table-very-condensed table-bordered" style={{ marginBottom: 0 }}>
        <thead>
          <tr>
            <th style={{ width: "30px" }} />
            <th>
              Technique
              <SearchBox
                type="text"
                className="form-control input-xs"
                value={techniqueFilter}
                onChange={(e) => setTechniqueFilter(e.target.value)}
                placeholder={"Filter by technique..."}
              />
            </th>
            <th>
              Matrix
              <SearchBox
                type="text"
                className="form-control input-xs"
                value={matrixFilter}
                onChange={(e) => setMatrixFilter(e.target.value)}
                placeholder={"Filter by matrix..."}
              />
            </th>
            <th>
              Test Name
              <SearchBox
                type="text"
                className="form-control input-xs"
                value={testNameFilter}
                onChange={(e) => setTestNameFilter(e.target.value)}
                placeholder={"Filter by test name..."}
              />
            </th>
            <th>Added At</th>
            <th>Added By</th>
          </tr>
        </thead>
        <tbody>
          {filteredTests.map((t) => (
            <tr>
              <td className="text-center">
                <input
                  type="checkbox"
                  checked={selectedIds.includes(t.id)}
                  onChange={(e) => select([t.id], e.target.checked)}
                />
              </td>
              <td>{t.technique}</td>
              <td className={!t.matrix && "empty"}>{t.matrix}</td>
              <td className={!t.measurement && "empty"}>{t.measurement}</td>
              <td className="nowrap">{t.added_at}</td>
              <td className="nowrap">{t.added_by}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
